import React, { useState } from 'react';
import styles from './Switcher.module.css';

interface SwitcherOption {
  label: string | JSX.Element | React.ReactNode;
  value: string;
}

interface SwitcherProps {
  options: SwitcherOption[];
  value?: string;
  onChange?: (value: string) => void;
}

const Switcher: React.FC<SwitcherProps> = ({ options, value, onChange }) => {

  const handleClick = (value: string) => {
    if (onChange) {
      onChange(value);
    }
  };

  return (
    <div className={styles.container}>
      {options.map((option) => (
        <button
          key={option.value}
          className={`${styles.option} ${value === option.value ? styles.active : ''}`}
          onClick={() => handleClick(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};

export default Switcher;
